<template lang='pug'>
.address-panel-container
    .info(@click='$emit("clickInfo", recipient)')
        .area {{ address }}
        .detail {{ recipient.address.details }}
        .man {{ recipient.name + " " + recipient.phone }}
    .arrow(@click='$emit("clickArrow", recipient)')
</template>

<script>
export default {
    props: {
        recipient: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        address() {
            const ks = ['country', 'province', 'city', 'district']
            return ks.map(k => this.recipient.address[k]).join(' ')
        }
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin.less';
.address-panel-container {
    display: flex;
    justify-content: space-between;
    padding: @spacing;
    align-items: center;
    .info {
        font-size: 0.8rem;
        line-height: 2;
        .detail {
            font-weight: bold;
        }
    }
    .arrow {
        .arrow(@size: 0.5rem, @color: #c0c0c0);
    }
}
</style>